module.exports = __webpack_public_path__ + "img/video-placeholder.99c39d4b.png";